<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="面试列表">
        <va-data-table
          :fields="fields"
          :data="interviews"
          :loading="loading"
          :totalPages="totalPage"
          @page-selected="listInterview"
          api-mode
        >
          <template slot="avatar" slot-scope="props">
            <img :src="props.rowData.avatar" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="typeSlot" slot-scope="props">
            <va-badge :color= computeStatus(props.rowData.status).color>
              {{ computeStatus(props.rowData.status).text }}
            </va-badge>
          </template>
          <template slot="startTime" slot-scope="props">
            {{ formatPeriodTime(props.rowData.startTime) }}
          </template>
          <template slot="interviewTime" slot-scope="props">
            {{ formatRegisterTime(props.rowData.startTime, props.rowData.endTime) }}
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye"
                :to='{path:`getInterview/${props.rowData.roomId}`}'/>
            </va-popover>
          </template>
        </va-data-table>
      </va-card>
    </div>
  </div>
</template>

<script>

import { formatTime, toMinSecFormat } from '@/utils/common'
import interviewApi from '../../api/interview'

export default {
  data () {
    return {
      message: ['Required field'],
      interviews: [],
      loading: true,
      allCount: 0,
      totalPage: null,
      inviterUid: null,
      inviterPage: false,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'id',
          title: 'id',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '5%',
        },
        {
          name: 'nickname',
          title: '用户名',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: 'position',
          title: '岗位',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: '__slot:typeSlot',
          title: '面试状态',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:startTime',
          title: '面试开始时间',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: '__slot:interviewTime',
          title: '面试时长',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: 'overallScore',
          title: '分数',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '5%',
        },
        {
          name: 'gradeLevel',
          title: '等级',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          title: '操作',
          titleClass: 'text-center',
          width: '5%',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.uid = this.$route.query.uid
    this.listInterview()
  },
  methods: {
    listInterview (pageNumber = 1) {
      this.loading = true
      const data = {
        pageSize: 50,
        pageNumber: pageNumber,
        uid: this.uid,
        startTime: this.startTime,
        endTime: this.endTime,
      }
      interviewApi.listInterview(data)
        .then(response => {
          this.interviews = response.interviewList
          this.totalCount = response.totalCount
          this.totalPage = response.totalPage
          this.loading = false
        })
    },
    computeStatus: function (status) {
      const data = {
        color: 'success',
        text: '初始化',
      }
      if (status === 1) {
        data.color = 'danger'
        data.text = '进行中'
      } else if (status === 2) {
        data.color = '#6be59c'
        data.text = '已结束'
      }
      return data
    },
    formatRegisterTime: function (startTime, endTime) {
      if (startTime > 0 && endTime > 0) {
        return toMinSecFormat(endTime - startTime)
      }
      return '-'
    },
    formatPeriodTime: function (start) {
      return formatTime(start)
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
</style>
